import { Navigate, useParams } from "react-router-dom";
import { useTranslations } from "next-intl";
import { AccessReportAdmin } from "@/components/admin/access-report-admin";
import { Heading, PageShell, Text } from "@/components/ui";
import { useAuthStore } from "@/stores/authStore";

/** H4: Admin → Access report (school admin only). */
export function TenantAdminAccessReportPage() {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const t = useTranslations("accessReport");
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }
  if (user?.role !== "tenant_admin") {
    return <Navigate to={`/t/${tenantSlug}/dashboard`} replace />;
  }

  return (
    <PageShell width="wide" data-testid="tenant-admin-access-report">
      <Heading as="h1" level="page">
        {t("title")}
      </Heading>
      <Text tone="muted" className="mt-2">
        {t("subtitle")}
      </Text>
      <div className="mt-8">
        <AccessReportAdmin />
      </div>
    </PageShell>
  );
}
